import { useEffect, useState } from "react";

export const useSessionState = (name, initialValue) => {
  const [value, setValue] = useState(
    JSON.parse(sessionStorage.getItem(name)) || initialValue || null,
  );

  useEffect(() => {
    sessionStorage.setItem(name, JSON.stringify(value));
  }, [name, value]);

  return [value, setValue];
};
